/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import {
  ApplySpaceTemplate,
  ComputedContentSourceDocument,
  ComputedContentSourceRevision,
  ContentLocation,
  ContentReferencesStats,
  ContentReferenceStatus,
  ContentReferenceUsage,
  JSONDocument,
  List,
  Revision,
  RevisionFile,
  RevisionPage,
  RevisionPageDocument,
  RevisionPageGroup,
  RevisionReusableContent,
  RevisionSemanticChanges,
  SearchPageResult,
  URL,
} from "./data-contracts";

/**
 * No description
 * @tags space-content
 * @name SearchSpaceContent
 * @summary Search content in a space
 * @request GET:/spaces/{spaceId}/search
 * @secure
 */

// @ts-ignore
export const searchSpaceContent: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
  };
  RequestQuery: {
    /** @maxLength 512 */
    query: string;
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: SearchPageResult[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/search",
  method: "get",
  streaming: false,
  tags: ["space-content"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags space-content
 * @name GetCurrentRevision
 * @summary Get a space current revision
 * @request GET:/spaces/{spaceId}/content
 * @secure
 */

// @ts-ignore
export const getCurrentRevision: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
  };
  RequestQuery: {
    /**
     * If `false` is passed, "git" mutable metadata will not returned. Passing `false` can optimize performances of the lookup.
     * @default true
     */
    metadata?: boolean;
    /**
     * If `false` is passed, content will not be computed
     * @default true
     */
    computed?: boolean;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: Revision;
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/content",
  method: "get",
  streaming: false,
  tags: ["space-content"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags space-content
 * @name ApplyTemplateToSpace
 * @summary Apply a template to a space.
 * @request POST:/spaces/{spaceId}/content/template
 * @secure
 */

// @ts-ignore
export const applyTemplateToSpace: {
  route: string;
  method: "post";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
  };
  RequestQuery: {};
  RequestBody: ApplySpaceTemplate;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 201;
} = {
  route: "/spaces/{spaceId}/content/template",
  method: "post",
  streaming: false,
  tags: ["space-content"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags space-content
 * @name ListPages
 * @summary List all space pages
 * @request GET:/spaces/{spaceId}/content/pages
 * @secure
 */

// @ts-ignore
export const listPages: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
  };
  RequestQuery: {
    /**
     * If `false` is passed, "git" mutable metadata will not returned. Passing `false` can optimize performances of the lookup.
     * @default true
     */
    metadata?: boolean;
    /**
     * If `false` is passed, content will not be computed
     * @default true
     */
    computed?: boolean;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: {
    pages: RevisionPage[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/content/pages",
  method: "get",
  streaming: false,
  tags: ["space-content"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags space-content
 * @name ListFiles
 * @summary List all space files
 * @request GET:/spaces/{spaceId}/content/files
 * @secure
 */

// @ts-ignore
export const listFiles: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
    /**
     * If `false` is passed, "git" mutable metadata will not returned. Passing `false` can optimize performances of the lookup.
     * @default true
     */
    metadata?: boolean;
    /**
     * If `false` is passed, content will not be computed
     * @default true
     */
    computed?: boolean;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: RevisionFile[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/content/files",
  method: "get",
  streaming: false,
  tags: ["space-content"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags space-content
 * @name GetFileById
 * @summary Get a space file by its ID
 * @request GET:/spaces/{spaceId}/content/files/{fileId}
 * @secure
 */

// @ts-ignore
export const getFileById: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
    /** The unique id of the file */
    fileId: string;
  };
  RequestQuery: {
    /**
     * If `false` is passed, "git" mutable metadata will not returned. Passing `false` can optimize performances of the lookup.
     * @default true
     */
    metadata?: boolean;
    /**
     * If `false` is passed, content will not be computed
     * @default true
     */
    computed?: boolean;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: RevisionFile;
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/content/files/{fileId}",
  method: "get",
  streaming: false,
  tags: ["space-content"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags space-content
 * @name ListSpaceFileBacklinks
 * @summary List all space file backlink locations
 * @request GET:/spaces/{spaceId}/content/files/{fileId}/backlinks
 * @secure
 */

// @ts-ignore
export const listSpaceFileBacklinks: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
    /** The unique id of the file */
    fileId: string;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: ContentLocation[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/content/files/{fileId}/backlinks",
  method: "get",
  streaming: false,
  tags: ["space-content"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags space-content
 * @name GetPageById
 * @summary Get a space page by its ID
 * @request GET:/spaces/{spaceId}/content/page/{pageId}
 * @secure
 */

// @ts-ignore
export const getPageById: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
    /** The unique id of the page */
    pageId: string;
  };
  RequestQuery: {
    /** Output format for the content. */
    format?: "document" | "markdown";
    /**
     * Controls whether the document should be evaluated.
     * - When set to `true`, the entire document will be evaluated.
     * - When set to `deterministic-only`, only expressions that depend
     *   exclusively on deterministic inputs will be evaluated.
     * @default false
     */
    evaluated?: boolean | "deterministic-only";
    /**
     * If `false` is passed, "git" mutable metadata will not returned. Passing `false` can optimize performances of the lookup.
     * @default true
     */
    metadata?: boolean;
    /**
     * If `false` is passed, content will not be computed
     * @default true
     */
    computed?: boolean;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: RevisionPage;
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/content/page/{pageId}",
  method: "get",
  streaming: false,
  tags: ["space-content"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags space-content, links, critical
 * @name ListPageLinksInSpace
 * @summary List all space page links
 * @request GET:/spaces/{spaceId}/content/page/{pageId}/links
 * @secure
 */

// @ts-ignore
export const listPageLinksInSpace: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "high";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
    /** The unique id of the page */
    pageId: string;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
    /**
     * Text to display to represent the reference. Possible values include:
     * - `ok` - No problems detected for this content reference.
     * - `broken` - The target does not exist in the revision.
     * - `in-app` - The target is a URL link pointing to an internal location in the app.
     */
    status?: ContentReferenceStatus;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    stats: ContentReferencesStats;
    items: ContentReferenceUsage[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/content/page/{pageId}/links",
  method: "get",
  streaming: false,
  tags: ["space-content", "links", "critical"],
  criticalityLevel: "high",
  deprecated: false,
};

/**
 * No description
 * @tags space-content
 * @name ListSpacePageBacklinks
 * @summary List all space page backlink locations
 * @request GET:/spaces/{spaceId}/content/page/{pageId}/backlinks
 * @secure
 */

// @ts-ignore
export const listSpacePageBacklinks: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
    /** The unique id of the page */
    pageId: string;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: ContentLocation[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/content/page/{pageId}/backlinks",
  method: "get",
  streaming: false,
  tags: ["space-content"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags space-content
 * @name GetPageByPath
 * @summary Get a space page by its path
 * @request GET:/spaces/{spaceId}/content/path/{pagePath}
 * @secure
 */

// @ts-ignore
export const getPageByPath: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
    /** The path of the page in the revision. */
    pagePath: string;
  };
  RequestQuery: {
    /** Output format for the content. */
    format?: "document" | "markdown";
    /**
     * Controls whether the document should be evaluated.
     * - When set to `true`, the entire document will be evaluated.
     * - When set to `deterministic-only`, only expressions that depend
     *   exclusively on deterministic inputs will be evaluated.
     * @default false
     */
    evaluated?: boolean | "deterministic-only";
    /**
     * If `false` is passed, "git" mutable metadata will not returned. Passing `false` can optimize performances of the lookup.
     * @default true
     */
    metadata?: boolean;
    /**
     * If `false` is passed, content will not be computed
     * @default true
     */
    computed?: boolean;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: RevisionPageDocument | RevisionPageGroup;
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/content/path/{pagePath}",
  method: "get",
  streaming: false,
  tags: ["space-content"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags space-content
 * @name GetReusableContentById
 * @summary Get a space reusable content by its ID
 * @request GET:/spaces/{spaceId}/content/reusable-contents/{reusableContentId}
 * @secure
 */

// @ts-ignore
export const getReusableContentById: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
    /** The unique id of the reusable content */
    reusableContentId: string;
  };
  RequestQuery: {
    /**
     * If `false` is passed, "git" mutable metadata will not returned. Passing `false` can optimize performances of the lookup.
     * @default true
     */
    metadata?: boolean;
    /**
     * If `false` is passed, content will not be computed
     * @default true
     */
    computed?: boolean;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: RevisionReusableContent;
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/content/reusable-contents/{reusableContentId}",
  method: "get",
  streaming: false,
  tags: ["space-content"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags space-content
 * @name GetComputedDocument
 * @summary Get a space computed document
 * @request POST:/spaces/{spaceId}/content/computed/document
 * @secure
 */

// @ts-ignore
export const getComputedDocument: {
  route: string;
  method: "post";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
  };
  RequestQuery: {
    /** Version of the schema used for the document. */
    schema?: "current" | "next";
  };
  RequestBody: {
    source: ComputedContentSourceDocument;
    /** Seed to use for the generation of IDs. */
    seed: string;
  };
  RequestHeaders: {};
  ResponseBody: JSONDocument;
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/content/computed/document",
  method: "post",
  streaming: false,
  tags: ["space-content"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags space-content
 * @name GetComputedRevision
 * @summary Get a space computed revision
 * @request POST:/spaces/{spaceId}/content/computed/revision
 * @secure
 */

// @ts-ignore
export const getComputedRevision: {
  route: string;
  method: "post";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
  };
  RequestQuery: {};
  RequestBody: {
    source: ComputedContentSourceRevision;
    /** Seed to use for the generation of IDs. */
    seed: string;
  };
  RequestHeaders: {};
  ResponseBody: {
    pages: RevisionPage[];
    files: RevisionFile[];
    reusableContents: RevisionReusableContent[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/content/computed/revision",
  method: "post",
  streaming: false,
  tags: ["space-content"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags space-content
 * @name GetDocumentById
 * @summary Get a space document by its ID
 * @request GET:/spaces/{spaceId}/documents/{documentId}
 * @secure
 */

// @ts-ignore
export const getDocumentById: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
    /** ID of the document in the space */
    documentId: string;
  };
  RequestQuery: {
    /** Version of the schema used for the document. */
    schema?: "current" | "next";
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: JSONDocument;
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/documents/{documentId}",
  method: "get",
  streaming: false,
  tags: ["space-content"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags space-content
 * @name GetRevisionById
 * @summary Get a space revision
 * @request GET:/spaces/{spaceId}/revisions/{revisionId}
 * @secure
 */

// @ts-ignore
export const getRevisionById: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
    /** The unique id of the revision */
    revisionId: string;
  };
  RequestQuery: {
    /**
     * If `false` is passed, "git" mutable metadata will not returned. Passing `false` can optimize performances of the lookup.
     * @default true
     */
    metadata?: boolean;
    /**
     * If `false` is passed, content will not be computed
     * @default true
     */
    computed?: boolean;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: Revision;
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/revisions/{revisionId}",
  method: "get",
  streaming: false,
  tags: ["space-content"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Return the semantic changes between a revision and its parent.
 * @tags space-content
 * @name GetRevisionSemanticChanges
 * @summary Get space revision semantic changes
 * @request GET:/spaces/{spaceId}/revisions/{revisionId}/changes
 * @secure
 */

// @ts-ignore
export const getRevisionSemanticChanges: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
    /** The unique id of the revision */
    revisionId: string;
  };
  RequestQuery: {
    /**
     * If `false` is passed, "git" mutable metadata will not returned. Passing `false` can optimize performances of the lookup.
     * @default true
     */
    metadata?: boolean;
    /**
     * If `false` is passed, content will not be computed
     * @default true
     */
    computed?: boolean;
    /**
     * Limit the number of changes returned
     * @default 10
     */
    limit?: number;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: RevisionSemanticChanges;
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/revisions/{revisionId}/changes",
  method: "get",
  streaming: false,
  tags: ["space-content"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags space-content
 * @name ListPagesInRevisionById
 * @summary List all pages in a space revision
 * @request GET:/spaces/{spaceId}/revisions/{revisionId}/pages
 * @secure
 */

// @ts-ignore
export const listPagesInRevisionById: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
    /** The unique id of the revision */
    revisionId: string;
  };
  RequestQuery: {
    /**
     * If `false` is passed, "git" mutable metadata will not returned. Passing `false` can optimize performances of the lookup.
     * @default true
     */
    metadata?: boolean;
    /**
     * If `false` is passed, content will not be computed
     * @default true
     */
    computed?: boolean;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: {
    pages: RevisionPage[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/revisions/{revisionId}/pages",
  method: "get",
  streaming: false,
  tags: ["space-content"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags space-content
 * @name ListFilesInRevisionById
 * @summary List all space revision files
 * @request GET:/spaces/{spaceId}/revisions/{revisionId}/files
 * @secure
 */

// @ts-ignore
export const listFilesInRevisionById: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
    /** The unique id of the revision */
    revisionId: string;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
    /**
     * If `false` is passed, "git" mutable metadata will not returned. Passing `false` can optimize performances of the lookup.
     * @default true
     */
    metadata?: boolean;
    /**
     * If `false` is passed, content will not be computed
     * @default true
     */
    computed?: boolean;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: RevisionFile[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/revisions/{revisionId}/files",
  method: "get",
  streaming: false,
  tags: ["space-content"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags space-content
 * @name GetFileInRevisionById
 * @summary Get a space revision file by its ID
 * @request GET:/spaces/{spaceId}/revisions/{revisionId}/files/{fileId}
 * @secure
 */

// @ts-ignore
export const getFileInRevisionById: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
    /** The unique id of the revision */
    revisionId: string;
    /** The unique id of the file */
    fileId: string;
  };
  RequestQuery: {
    /**
     * If `false` is passed, "git" mutable metadata will not returned. Passing `false` can optimize performances of the lookup.
     * @default true
     */
    metadata?: boolean;
    /**
     * If `false` is passed, content will not be computed
     * @default true
     */
    computed?: boolean;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: RevisionFile;
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/revisions/{revisionId}/files/{fileId}",
  method: "get",
  streaming: false,
  tags: ["space-content"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags space-content
 * @name GetPageInRevisionById
 * @summary Get a space revision page by its ID
 * @request GET:/spaces/{spaceId}/revisions/{revisionId}/page/{pageId}
 * @secure
 */

// @ts-ignore
export const getPageInRevisionById: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
    /** The unique id of the revision */
    revisionId: string;
    /** The unique id of the page */
    pageId: string;
  };
  RequestQuery: {
    /** Output format for the content. */
    format?: "document" | "markdown";
    /**
     * Controls whether the document should be evaluated.
     * - When set to `true`, the entire document will be evaluated.
     * - When set to `deterministic-only`, only expressions that depend
     *   exclusively on deterministic inputs will be evaluated.
     * @default false
     */
    evaluated?: boolean | "deterministic-only";
    /**
     * If `false` is passed, "git" mutable metadata will not returned. Passing `false` can optimize performances of the lookup.
     * @default true
     */
    metadata?: boolean;
    /**
     * If `false` is passed, content will not be computed
     * @default true
     */
    computed?: boolean;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: RevisionPage;
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/revisions/{revisionId}/page/{pageId}",
  method: "get",
  streaming: false,
  tags: ["space-content"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags space-content
 * @name GetPageDocumentInRevisionById
 * @summary Get the document of a page in a revision
 * @request GET:/spaces/{spaceId}/revisions/{revisionId}/page/{pageId}/document
 * @secure
 */

// @ts-ignore
export const getPageDocumentInRevisionById: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
    /** The unique id of the revision */
    revisionId: string;
    /** The unique id of the page */
    pageId: string;
  };
  RequestQuery: {
    /**
     * Controls whether the document should be evaluated.
     * - When set to `true`, the entire document will be evaluated.
     * - When set to `deterministic-only`, only expressions that depend
     *   exclusively on deterministic inputs will be evaluated.
     * @default false
     */
    evaluated?: boolean | "deterministic-only";
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: JSONDocument;
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/revisions/{revisionId}/page/{pageId}/document",
  method: "get",
  streaming: false,
  tags: ["space-content"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags space-content
 * @name GetPageInRevisionByPath
 * @summary Get a space revision page by its path
 * @request GET:/spaces/{spaceId}/revisions/{revisionId}/path/{pagePath}
 * @secure
 */

// @ts-ignore
export const getPageInRevisionByPath: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
    /** The unique id of the revision */
    revisionId: string;
    /** The path of the page in the revision. */
    pagePath: string;
  };
  RequestQuery: {
    /** Output format for the content. */
    format?: "document" | "markdown";
    /**
     * Controls whether the document should be evaluated.
     * - When set to `true`, the entire document will be evaluated.
     * - When set to `deterministic-only`, only expressions that depend
     *   exclusively on deterministic inputs will be evaluated.
     * @default false
     */
    evaluated?: boolean | "deterministic-only";
    /**
     * If `false` is passed, "git" mutable metadata will not returned. Passing `false` can optimize performances of the lookup.
     * @default true
     */
    metadata?: boolean;
    /**
     * If `false` is passed, content will not be computed
     * @default true
     */
    computed?: boolean;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: RevisionPageDocument | RevisionPageGroup;
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/revisions/{revisionId}/path/{pagePath}",
  method: "get",
  streaming: false,
  tags: ["space-content"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags space-content
 * @name GetReusableContentInRevisionById
 * @summary Get a space revision reusable content by its ID
 * @request GET:/spaces/{spaceId}/revisions/{revisionId}/reusable-contents/{reusableContentId}
 * @secure
 */

// @ts-ignore
export const getReusableContentInRevisionById: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
    /** The unique id of the revision */
    revisionId: string;
    /** The unique id of the reusable content */
    reusableContentId: string;
  };
  RequestQuery: {
    /**
     * If `false` is passed, "git" mutable metadata will not returned. Passing `false` can optimize performances of the lookup.
     * @default true
     */
    metadata?: boolean;
    /**
     * If `false` is passed, content will not be computed
     * @default true
     */
    computed?: boolean;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: RevisionReusableContent;
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/revisions/{revisionId}/reusable-contents/{reusableContentId}",
  method: "get",
  streaming: false,
  tags: ["space-content"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags space-content
 * @name GetReusableContentDocumentInRevisionById
 * @summary Get the document of a reusable content in a revision
 * @request GET:/spaces/{spaceId}/revisions/{revisionId}/reusable-contents/{reusableContentId}/document
 * @secure
 */

// @ts-ignore
export const getReusableContentDocumentInRevisionById: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
    /** The unique id of the revision */
    revisionId: string;
    /** The unique id of the reusable content */
    reusableContentId: string;
  };
  RequestQuery: {
    /**
     * Controls whether the document should be evaluated.
     * - When set to `true`, the entire document will be evaluated.
     * - When set to `deterministic-only`, only expressions that depend
     *   exclusively on deterministic inputs will be evaluated.
     * @default false
     */
    evaluated?: boolean | "deterministic-only";
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: JSONDocument;
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/revisions/{revisionId}/reusable-contents/{reusableContentId}/document",
  method: "get",
  streaming: false,
  tags: ["space-content"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags space-content
 * @name GetSpacePdf
 * @summary Get a URL of the content of a space as PDF
 * @request GET:/spaces/{spaceId}/pdf
 * @secure
 */

// @ts-ignore
export const getSpacePDF: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the space */
    spaceId: string;
  };
  RequestQuery: {
    /** Generate a PDF only for the provided page. */
    only?: boolean;
    /** ID of a specific page to generate a PDF for. */
    page?: string;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: {
    /** Temporary URL to print the content. The URL will work for 1h. */
    url: URL;
  };
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/pdf",
  method: "get",
  streaming: false,
  tags: ["space-content"],
  criticalityLevel: "low",
  deprecated: false,
};
